import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

// export const currentPresetAtom = atom(null);
export const currentComponentAtom = atomFamily((id) => atom(null));
